import { Box, styled } from '@mui/material'
import { FC, ReactNode } from 'react'

const Title = styled(Box)`
  font-size: 20px;
  color: #ffffff;
  line-height: 26px;
`

const Subtitle = styled(Box)`
  font-family: var(--font-Apeiron);
  font-size: 16px;
  color: #c4c4c4;
  line-height: 16.5px;
  margin-top: 5px;
`

const Container = styled(Box)`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 16px 0 4px 20px;
`

const ApeironSectionTitle: FC<Props> = (props: Props) => {
  const { children, className, title } = props

  return (
    <Container className={className}>
      <Title className='Custom-Title'>{title}</Title>
      <Subtitle className='Custom-Subtitle'>{title}</Subtitle>
      {children}
    </Container>
  )
}

type Props = {
  children?: ReactNode
  className?: string
  title: string
}

export default ApeironSectionTitle
